import CssBaseline from '@material-ui/core/CssBaseline'
import React, { Component, Fragment } from 'react'
import Routes from './Routes'

export default class App extends Component {
    render() {
        return (
            <Fragment>
                <CssBaseline />
                <Routes />
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/App.js